<template lang="pug">
  .evaluation
    el-row(
      v-for="item in ITEMS"
      :key="item.key"
    )
      el-col.required(:span="4") {{ $t(item.label) }}
      el-col(:span="4")
        el-rate(
          v-model="data[item.key]"
          :disabled="view"
          show-score
        )
      el-col(v-show="data[item.key] === 0 && validate" :span="10")
        span.required-text {{ $t('请填写必填项') }}

    el-row
      el-col(:span="4") {{ $t('备注') }}
      el-col(:span="7" style="position: relative")
        span(v-if="view")
          display-text-container(:text="data.remark")
        template(v-else)
          el-input(
            v-model="data.remark"
            type="textarea"
            :disabled="view"
            :rows="8"
            style="width: 380px"
            :placeholder="$t('备注不多于500字')"
            :class="{'has-error': errors.has('remark_field') }"
            v-validate="'max:500'"
            data-vv-as="remark_field"
            name="remark_field"
          )
          p(class="input-error") {{ errors.first('remark_field') }}
</template>

<script>
import DisplayTextContainer from '@/components/DisplayTextContainer'

const ITEMS = [
  {
    key: 'satisfaction',
    label: '客户服务满意度'
  },
  {
    key: 'creativity',
    label: '创意能力'
  },
  {
    key: 'execution',
    label: '执行能力'
  },
  {
    key: 'development',
    label: '开发能力'
  },
  {
    key: 'cost_control',
    label: '成本控制'
  }
]

export default {
  components: {
    DisplayTextContainer
  },
  props: {
    data: {
      type: Object,
      default () {
        return {
          satisfaction: 0,
          creativity: 0,
          execution: 0,
          development: 0,
          cost_control: 0,
          remark: ''
        }
      }
    },
    view: {
      type: Boolean,
      default: true
    },
    validate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      ITEMS
    }
  }
}
</script>

<style lang="stylus">
.evaluation
  .el-rate
    line-height 1.6
    .el-rate__item
      height 20px
  .el-row
    .el-col-10
      line-height 23px
  .required-text
    font-size 12px
    color red
</style>
